/**
 * The vendor form lives in AppShell's nested overflow scroller. Native
 * `scrollIntoView({ block: "start" })` on a late section (Onboarding Questions)
 * tries to pin that section to the top of the viewport and inflates the
 * scroll range with empty space below the footer.
 */

export function findVerticalScrollParent(element: HTMLElement): HTMLElement | null {
  let parent = element.parentElement;
  while (parent) {
    const { overflowY } = getComputedStyle(parent);
    if (overflowY === "auto" || overflowY === "scroll" || overflowY === "overlay") {
      return parent;
    }
    parent = parent.parentElement;
  }
  return null;
}

function sectionScrollBehavior(): ScrollBehavior {
  if (typeof window.matchMedia !== "function") return "auto";
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth";
}

export function scrollSectionToStart(element: HTMLElement): void {
  const behavior = sectionScrollBehavior();
  const scroller = findVerticalScrollParent(element);
  if (!scroller) {
    element.scrollIntoView({ behavior, block: "nearest" });
    return;
  }

  const scrollMarginTop = Number.parseFloat(getComputedStyle(element).scrollMarginTop) || 0;
  const unclamped =
    scroller.scrollTop +
    (element.getBoundingClientRect().top - scroller.getBoundingClientRect().top) -
    scrollMarginTop;
  const maxTop = Math.max(0, scroller.scrollHeight - scroller.clientHeight);
  scroller.scrollTo({
    top: Math.min(Math.max(0, unclamped), maxTop),
    behavior,
  });
}
